import { AppDispatch, AppThunk, AsyncAppThunk } from "store/store";
import { httpWrapper } from "../../utils/http";
import { SMS_API_BASE } from "../../constants";
import { handleError } from "errors/errors";
import {
  listClientSettingsStart,
  listClientSettingsSuccess,
  listClientSettingsError,
  addOrUpdateClientSettingsStart,
  addOrUpdateClientSettingsSuccess,
  addOrUpdateClientSettingsError,
  getLanguageSettingsListStart,
  getLanguageSettingsListSuccess,
  getLanguageSettingsListError,
} from "./ClientSettingsSlice";
import {
  ClientSettingsWithDetails,
  ClientSettingsAddForm,
  LanguageSettings,
} from "../../api/sms-api";
import i18n from "i18n";
import { showNotification } from "utils/notifications";

export const listClientSettings = (
  surveyType: string,
  discriminator: string,
  languageSettingsCode: string,
  isBlankLoad?: boolean
): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(listClientSettingsStart());
  try {
    let clientSettings = await httpWrapper<Array<ClientSettingsWithDetails>>(
      "GET",
      `${SMS_API_BASE}/client_settings/all_with_session`,
      { surveyType, discriminator, languageSettingsCode }
    );
    if (isBlankLoad) {
      clientSettings = clientSettings.map((item: ClientSettingsWithDetails) =>
        Object.assign({}, item, { clientSettings: undefined })
      );
    }
    dispatch(listClientSettingsSuccess(clientSettings));
  } catch (e) {
    handleError(e);
    dispatch(listClientSettingsError(e));
  }
};

export const addOrUpdateClientSettings = (
  params: Array<ClientSettingsAddForm>
): AsyncAppThunk<void> => async (dispatch: AppDispatch) => {
  dispatch(addOrUpdateClientSettingsStart());
  try {
    await httpWrapper("POST", `${SMS_API_BASE}/client_settings`, {
      forms: params,
    });

    showNotification(i18n.t("clientSettings.createSuccess"));
    dispatch(addOrUpdateClientSettingsSuccess());
  } catch (e) {
    handleError(e);
    dispatch(addOrUpdateClientSettingsError(e));
  }
};

export const getLanguageSettingsListAll = () => async (
  dispatch: AppDispatch
) => {
  dispatch(getLanguageSettingsListStart());
  try {
    const languageSettingsList = await httpWrapper<Array<LanguageSettings>>(
      "GET",
      `${SMS_API_BASE}/surveys/language_settings`,
      {}
    );
    dispatch(getLanguageSettingsListSuccess(languageSettingsList));
  } catch (e) {
    handleError(e);
    dispatch(getLanguageSettingsListError());
  }
};
